import api, { Notifiable } from "../api";

export interface AContrarComuns {
    key: string;
    numeroLinha: number;
    codigoPacote: string
    nome: string

    totalOrcado: number;
    totalContratado: number;
    totalExecutado: number;
    totalRequisitado: number;
    totalCompromissadoAno: number;
    totalAContratar: number;
    totalForecast: number;
    totalSaldo: number;

    orcado: number;
    contratado: number;
    executado: number;
    requisitado: number;
    compromissadoAno: number;
    aContratar: number;
    forecast: number;
    saldo: number;
    possuiComentario: boolean;
    tipoConsolidadoPlurianualCodigo: number;
    numeroNivel: number
}
export interface ResultadoRelatorioPluriAnual extends AContrarComuns {
    tipoConsolidadoPlurianualCodigo: number;
    crfContaContabilCcId: string;
    keyNivel1: string;
    keyNivel2: string;
}


export interface AContratarViewResultCrfTipoConsolidadoPlurianual extends AContrarComuns {
    crfContaContabilCcId: string;
    children: Array<ResultadoRelatorioPluriAnual>
}

export interface AContratarCrfContaContabil extends AContrarComuns {
    crfAcronimoAgrupadorId: string;
    children: Array<AContratarViewResultCrfTipoConsolidadoPlurianual>
}

export interface AContratarViewResult {
    totalOrcado: number
    totalContratado: number
    totalExecutado: number
    totalRequisitado: number
    totalCompromissadoAno: number
    totalAContratar: number
    totalForecast: number
    totalSaldo: number,
    children: Array<AContratarCrfContaContabil>
}

export interface AContratarEditValue {
    crfContaContabilCcId: string;
    novoValor: number;
    key: string
}

export interface FromComentarioAContratar extends Notifiable {
    crfContaContabilCcId: string;
    comentario: string;
}
export interface MesnagemAContratar {
    nomeUsuario: string;
    dataHoraInclusao: string;
    mensagem: string;
}

export const getAContratarByCrfProjetoId = (crfProjetoId: string) => {
    return api.get<AContratarViewResult>(`crfAContratar/getAContratarByCrfProjetoId/${crfProjetoId}`);
}

export const updateAContratarByCrfContaContabilCcId = (values: AContratarEditValue) => {
    return api.put(`crfAContratar/updateAContratarByCrfContaContabilCcId/`, values);
}

export const salvarComentarioAContratar = (from: FromComentarioAContratar) => {
    return api.put(`crfAContratar/salvarComentarioAContratar/`, from);
}

export const getAllMensagemAContratar = (crfContaContabilCcId: string) => {
    return api.get<Array<MesnagemAContratar>>(`crfAContratar/getAllMensagemAContratar/${crfContaContabilCcId}`);
}